import { Text } from '../../cdl/Text/Text';
import { formatDateTime } from '../../common/helpers/formatDateTime.helper';
import { useRole } from '../../common/hooks/useRole';
import { IconDot } from '../../common/icons/cdl/Dot';
import { Box } from '../../common/ui/Box';

import { getSenderNameBySenderType } from './helpers';
import type { OfferChatMessage } from './types';

interface UserTimelineItemProps {
    message: OfferChatMessage;
    hideHeader?: boolean;
}

export const UserTimelineItem = ({ message, hideHeader }: UserTimelineItemProps) => {
    const role = useRole();
    const senderName = getSenderNameBySenderType(message);
    const absoluteTime = formatDateTime({
        date: message.dateCreated,
    });
    const userScope = role?.user?.userType === 'ADMIN' ? 'CUSTOMER' : role?.user?.userType;
    const isOutbound = userScope ? message.receiverType !== userScope : false;

    return (
        <Box padding={16} borderRadius={8} backgroundColor={isOutbound ? 'background.subtle' : 'background.inset'}>
            {hideHeader ? null : (
                <Box display="flex" gap={8} alignItems="center" marginBottom={8}>
                    <Box
                        width="16px"
                        height="16px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexShrink={0}
                        color="foreground.subtle"
                    >
                        <IconDot width={16} height={16} />
                    </Box>
                    <Text variant="small" fontWeight={500} style={{ userSelect: 'none' }}>
                        {senderName}
                    </Text>
                    <Text variant="small" color="foreground.muted" style={{ userSelect: 'none' }}>
                        {absoluteTime}
                    </Text>
                </Box>
            )}
            <Text variant="body" style={{ whiteSpace: 'break-spaces' }}>
                {message.message}
            </Text>
        </Box>
    );
};
